import commonMixin from '@/mixins/templates/common';
import { ABtn } from '@maisaedu/ui-components-a-btn';
import { mapGetters } from 'vuex';
export default {
  props: {
    isOpen: {
      type    : Boolean,
      default : false
    }
  },
  mixins     : [commonMixin],
  components : {
    ABtn
  },
  methods: {
    confirm() {
      const hasKeyOnLocalStorage = localStorage.getItem('contentMigration');
      const hasUserIdOnLocalStorage = hasKeyOnLocalStorage && JSON.parse(localStorage.getItem('contentMigration'))[this.getUserId];
      const hasCourseIdOnLocalStorage = hasKeyOnLocalStorage && hasUserIdOnLocalStorage && JSON.parse(localStorage.getItem('contentMigration'))[this.getUserId].includes(this.$route.params.courseId);

      if (!hasKeyOnLocalStorage) {
        const params = {
          [this.getUserId]: [this.$route.params.courseId]
        };

        localStorage.setItem('contentMigration', JSON.stringify(params));
      } else if (!hasUserIdOnLocalStorage) {
        const json = JSON.parse(localStorage.getItem('contentMigration'));
        const newJson = {
          ...json,
          [this.getUserId]: [this.$route.params.courseId]
        };

        localStorage.setItem('contentMigration', JSON.stringify(newJson));
      } else if (!hasCourseIdOnLocalStorage) {
        const json = JSON.parse(localStorage.getItem('contentMigration'));
        json[this.getUserId].push(this.$route.params.courseId);
        localStorage.setItem('contentMigration', JSON.stringify(json));
      }

      this.$emit('closeDialog');
    }
  },
  computed: {
    ...mapGetters({
      getUserId: '_core/user/getUserId'
    })
  }
};
